import RangeTouch from 'rangetouch'
import { onUnmounted } from 'vue'

export function useRangeTouch (selectors: string[]) {
  const rangeTouchs: Array<typeof RangeTouch> = []
  function init () {
    selectors.forEach(selector => {
      const rangeTouch = new RangeTouch(selector)
      rangeTouchs.push(rangeTouch)
    })
  }
  onUnmounted(() => {
    rangeTouchs.forEach(rangeTouch => {
      rangeTouch.destroy()
    })
  })

  return {
    init
  }
}
